//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import '@legacy-components/content/library-grid-content/LibraryGridContent';

(function() {
  const curalate = angular.module('curalate');

    /**
     * Component for rendering a masonry grid of content library items.
     * @param {object} filters - filter object used as parameters when requesting content
     * @param {string} collectionId - id of collection if this component is being used to show items for a collection
     * @param {boolean} ready - this component won't request items until ready is set to true. This allows waiting until filters, or any other criteria, are
     * ready before making API requests.
     * @param {string} viewMode - viewMode used for masonry layout
     */
  curalate.component('contentLibraryContentGrid', {
    bindings: {
      filters: '<',
      collectionId: '<',
      ready: '<?',
      viewMode: '<',
      detailLinkClicked: '&',
      scrollContainer: '<',
    },
    template: require('@legacy-components/content/content-library-content-grid/content-library-content-grid.html'),
    controller: [
      '$log',
      '$scope',
      'CollectionsService',
      'CONTENT',
      'ContentLibraryItemsService',
      'ContentLibraryService',
      'CURRENT_LOADER_OPTIONS',
      'SEARCH_FILTERS',
      'SearchFilterService',
      function(
                $log,
                $scope,
                CollectionsService,
                CONTENT,
                ContentLibraryItemsService,
                ContentLibraryService,
                CURRENT_LOADER_OPTIONS,
                SEARCH_FILTERS,
                SearchFilterService,
            ) {
        const self = this;

        self.isGridLoaded = false;
        self.items = [];
        self.totalItemCount = 0;

        self.CURRENT_LOADER_OPTIONS = CURRENT_LOADER_OPTIONS;
        const STATUS_REFRESH = CONTENT.ASYNC_ACTIONS.REFRESH;
        let endOfItemsReached = false;

        const updateCurrentLoader = function() {
          if (self.unableToAccessCollection || (endOfItemsReached && self.outstandingAsyncAction === null)) {
            self.currentLoader = CURRENT_LOADER_OPTIONS.NO_LOADER;
          } else if (self.outstandingAsyncAction === STATUS_REFRESH || !self.itemsLoaded || !self.collectionLoaded) {
            self.currentLoader = CURRENT_LOADER_OPTIONS.MAIN_LOADER;
          } else {
            self.currentLoader = CURRENT_LOADER_OPTIONS.INFINITE_SCROLL_LOADER;
          }
        };

        const refreshContentWithFilters = function() {
          if (self.ready) {
            ContentLibraryItemsService.configure(/* don't preload thumbnail urls */ false, 10);
            ContentLibraryItemsService.refreshContent(self.filters);
          }
        };

        self.onGridLoadedRefresh = function() {
          self.isGridLoaded = true;
        };

        const handleItemStateUpdate = function(itemState) {
          $scope.$applyAsync(() => {
            self.items = itemState.items;
            endOfItemsReached = itemState.endOfItemsReached;

            // Use this to determine when we've reached the end of all available items
            //  not just the currently-fetched set of items.
            self.totalItemCount = itemState.itemCount;
            updateCurrentLoader();
          });
        };

        const handleQueuedUploadsUpdate = function(queuedUploads) {
          $scope.$applyAsync(() => {
            self.queuedUploads = queuedUploads;
          });
        };

        this.fetchMoreContent = function() {
          if (self.ready) {
            ContentLibraryItemsService.fetchAdditionalContent(/* current item count */ self.items.length);
          }
        };

        ContentLibraryItemsService.getAsyncStatus().subscribe((status) => {
          $scope.$applyAsync(() => {
            if (self.outstandingAsyncAction === STATUS_REFRESH && status === null) {
              self.itemsLoaded = true;
            }
            self.outstandingAsyncAction = status;
            updateCurrentLoader();
          });
        });

        const refreshCollections = function() {
          CollectionsService.getCollections()
                        .map((state) => {
                          self.collectionStateSet = true;
                          return _(state.collections).findWhere({ id: self.collectionId });
                        })
                        .do((collection) => {
                          if (!angular.isDefined(collection) && self.collectionId) {
                            self.unableToAccessCollection = true;
                          } else {
                            self.unableToAccessCollection = false;
                          }
                        })
                        .filter((collection) => { return angular.isDefined(collection); })
                        .subscribe((collection) => {
                          self.hasInclusionarySettings = Object.entries(collection.sources).some(([, sourceVal]) => {
                            return sourceVal === true || (Array.isArray(sourceVal) && sourceVal.length > 0);
                          });
                          self.collectionLoaded = true;
                          updateCurrentLoader();
                        });
        };

        this.$onInit = function() {
          ContentLibraryItemsService.getItemState().subscribe(handleItemStateUpdate, $log.error);
          ContentLibraryItemsService.getQueuedUploads().subscribe(handleQueuedUploadsUpdate, $log.error);
          self.ready = angular.isDefined(self.ready) ? self.ready : true;

          ContentLibraryService.hasLibraryContentObservable.subscribe(
                        (r) => {
                          self.hasLibraryContent = r;
                        },
                    );

                    // If we're in the Media Library and not a collection, we don't need to test this case.
          self.collectionLoaded = _(self.collectionId).isUndefined();
          self.itemsLoaded = false;
          self.unableToAccessCollection = false;
          updateCurrentLoader();
          self.contentFilterCount = 0;

          SearchFilterService.getObservableForFilterSet(SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS).subscribe((update) => {
            self.contentFilterCount = update.filterCount;
          });
          refreshCollections();
        };

        this.$onChanges = function(changesObj) {
          let refreshContent = false;
          if (changesObj.filters && !angular.equals(changesObj.filters.currentValue, changesObj.filters.previousValue)) {
            refreshContent = true;
          }
                    // if ready changes from false to true, trigger a refresh
          if (changesObj.ready && !changesObj.ready.previousValue && changesObj.ready.currentValue) {
            refreshContent = true;
          }

          if (refreshContent) {
            refreshContentWithFilters();
          }
        };
      },
    ],
  });
})();
